import React, { useState } from "react";

// Mock data for Banner List
const bannerData = [
  { srNo: 1, image: "", status: "Active" },
  { srNo: 2, image: "", status: "Active" },
];

const AddAppBanner = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageError, setImageError] = useState(null);
  const [bannerList, setBannerList] = useState(bannerData);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate image size (minimum 1024x303)
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width >= 1024 && img.height >= 303) {
          setSelectedImage(file);
          setImageError(null);
        } else {
          setImageError("Please upload an image with minimum dimensions of 1024x303.");
          setSelectedImage(null);
        }
      };
    }
  };

  const handleAddBanner = () => {
    if (!selectedImage) {
      setImageError("Please upload a valid image.");
      return;
    }

    const newBanner = {
      srNo: bannerList.length + 1,
      image: selectedImage.name,
      status: "Active", // Default status as active
    };

    setBannerList([...bannerList, newBanner]);
    setSelectedImage(null); // Reset after adding
    setImageError(null); // Reset image error
  };

  const handleToggleStatus = (srNo) => {
    const updatedList = bannerList.map((banner) =>
      banner.srNo === srNo ? { ...banner, status: banner.status === "Active" ? "Inactive" : "Active" } : banner
    );
    setBannerList(updatedList);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Add App Banner Image</h2>
      <div style={styles.uploadSection}>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={styles.fileInput}
        />
        <div style={styles.fileName}>
          {selectedImage ? selectedImage.name : "No file chosen"}
        </div>
        {imageError && <p style={styles.errorText}>{imageError}</p>}
        <button
          onClick={handleAddBanner}
          style={styles.addButton}
        >
          Add
        </button>
      </div>

      <h3 style={styles.bannerListHeader}>Banner List</h3>
      <table style={styles.table}>
        <thead>
          <tr style={styles.tableHeaderRow}>
            <th style={styles.tableHeader}>Sr. No.</th>
            <th style={styles.tableHeader}>Image</th>
            <th style={styles.tableHeader}>Action</th>
          </tr>
        </thead>
        <tbody>
          {bannerList.map((banner) => (
            <tr key={banner.srNo} style={styles.tableRow}>
              <td style={styles.tableCell}>{banner.srNo}</td>
              <td style={styles.tableCell}>{banner.image || "No image"}</td>
              <td style={styles.tableCell}>
                <button
                  onClick={() => handleToggleStatus(banner.srNo)}
                  style={styles.toggleButton}
                >
                  {banner.status === "Active" ? "Deactivate" : "Activate"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    fontSize: "24px",
    color: "#2c3e50",
    marginBottom: "20px",
  },
  uploadSection: {
    marginBottom: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  fileInput: {
    padding: "10px",
    fontSize: "14px",
    color: "#34495e",
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginBottom: "10px",
  },
  fileName: {
    fontSize: "14px",
    color: "#34495e",
    marginBottom: "10px",
  },
  errorText: {
    color: "red",
    fontSize: "14px",
    marginBottom: "10px",
  },
  addButton: {
    padding: "10px 20px",
    backgroundColor: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  bannerListHeader: {
    textAlign: "center",
    fontSize: "20px",
    color: "#34495e",
    marginBottom: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeaderRow: {
    backgroundColor: "#2c3e50",
    color: "#fff",
  },
  tableHeader: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  tableRow: {
    backgroundColor: "#f9f9f9",
    transition: "background-color 0.3s ease",
  },
  tableCell: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  toggleButton: {
    padding: "6px 12px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default AddAppBanner;
